import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-booking-done',
  templateUrl: './booking-done.component.html',
  styleUrls: ['./booking-done.component.scss']
})
export class BookingDoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
